const MessageConstant = {
    // Session/Authentication messages
    SESSION_INVALID: 'You have been logged in from another device.',
    SESSION_EXPIRED: 'Your session has expired. Please login again.',
    SESSION_EXPIRED_GENERIC: 'Session expired. Please login again.',
    TOKEN_EXPIRED: 'Access token expired',
    TOKEN_INVALID: 'Invalid access token',
    TOKEN_REQUIRED: 'Access token required',
    AUTH_ERROR: 'Authentication service error',

    // Login messages
    LOGIN_REQUIRED: 'Please login to continue',
    LOGIN_SUCCESS: 'Login successful',
    LOGIN_FAILED: 'Login failed',
    LOGOUT_SUCCESS: 'Logout successful',

    // User messages
    USER_NOT_FOUND: 'User not found',
    USER_ALREADY_EXISTS: 'User already exists',
    INVALID_CREDENTIALS: 'Invalid email or password',

    // Validation messages
    VALIDATION_ERROR: 'Validation error',
    INVALID_INPUT: 'Invalid input provided',
    VALIDATION_REQUIRED_FIELDS: 'Please fill in all required fields',

    // Payment/Checkout messages
    NO_PACKAGE_SELECTED: 'Please select a package first',
    PAYMENT_CONFIG_ERROR: 'Payment system configuration error. Please contact support.',
    PAYMENT_CONFIG_WARNING: 'Payment configuration warning: environment mismatch',
    PAYMENT_ERROR: 'Payment error',
    PAYMENT_ERROR_UNKNOWN: 'Unknown error',
    PAYMENT_INIT_FAILED: 'Failed to initialize payment system.',
    PAYMENT_LOAD_FAILED: 'Failed to load payment system. Please try again.',
    PAYMENT_LOADING: 'Payment system is loading. Please wait...',
    PACKAGE_INFO_MISSING: 'Package information is missing',
    PACKAGE_NOT_CONFIGURED: 'Package is not configured for payment. Please contact support.',
    CHECKOUT_FAILED: 'Failed to open checkout. Please try again.',

    // Support/Bug/Refund messages
    SUPPORT_REQUEST_SUCCESS: 'Support request submitted successfully. Our team will respond within 24 hours.',
    BUG_REPORT_SUCCESS: 'Bug report submitted successfully. Our team will investigate this issue.',
    REFUND_REQUEST_SUCCESS: 'Refund request submitted successfully. Our team will review your request within 3-5 business days.',

    // Generic messages
    SUCCESS: 'Operation completed successfully',
    ERROR: 'An error occurred',
    LOADING: 'Loading...',
    INITIALIZING: 'Initializing...'
};

export default MessageConstant;
